import format from 'date-fns/format'

const startOfToday = format(new Date(), "yyyy-MM-dd'T00:00:00'xxx")
const endOfToday = format(new Date(), "yyyy-MM-dd'T23:59:59'xxx")

// Action Types
export const SET_DATA = 'dataCleanup/setData'
export const SET_FILTERS = 'dataCleanup/setFilters'
export const SET_LOADING = 'dataCleanup/setLoading'
// Action Creators
export const setData = (payload) => ({ type: SET_DATA, payload })
export const setFilters = (payload) => ({ type: SET_FILTERS, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })

// State
export const initialState = {
  data: {
    agents: [],
    scorecardConfigs: [],
    modalOpen: false,
    calls: [],
    deletionError: null,
    flagsToClear: {
      callMedia: {
        audio: false,
        video: false,
        transcript: false,
        summary: false,
      },
      callScore: {
        scorecards: false,
        qaFeedback: false,
      },
      coaching: {
        coachingTask: false,
        coachingNote: false,
      },
      compliance: {
        complianceTask: false,
        complianceNote: false,
      },
    },
  },
  filters: {
    startDate: startOfToday,
    endDate: endOfToday,
    organizationId: 1,
    agents: [],
    scorecards: [],
    scorecardConfigsToDelete: [],
  },
  loading: {
    calls: false,
    scorecardConfigs: false,
    clearData: false,
  },
}

export default function dataCleanupReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      return { ...state, data: { ...state.data, ...action.payload } }
    case SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } }
    case SET_LOADING:
      return { ...state, loading: { ...state.loading, ...action.payload } }
    default:
      return state
  }
}
